import type { CrmDataTypeConfig } from "./types";

/**
 * Single source of truth for CRM data type configurations
 */
export const CRM_DATA_TYPE_CONFIG: Record<string, CrmDataTypeConfig> = {
  accounts: {
    displayName: "Accounts",
    toolType: "load_positions_transactions",
    validationKey: "accounts",
    order: 1,
  },
  contacts: {
    displayName: "Contacts",
    toolType: "load_contacts",
    validationKey: "contacts",
    order: 2,
  },
  notes: {
    displayName: "Notes",
    toolType: "load_notes",
    validationKey: "notes",
    order: 3,
  },
  comm_pref: {
    displayName: "Communication Preferences",
    toolType: "load_comm_prefs",
    validationKey: "comm_prefs",
    order: 4,
  },
};

/**
 * Auto-derived type from the configuration object keys
 */
export type CrmDataType = keyof typeof CRM_DATA_TYPE_CONFIG;

/**
 * Mapping of data types to tool types
 * Used for reverse lookup of tool types from data types
 */
export const DATA_TYPE_TO_TOOL_TYPE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(CRM_DATA_TYPE_CONFIG).map(([key, config]) => [key, config.toolType]),
);

/**
 * Predefined order for tools configuration when sending to API
 */
export const TOOL_ORDER_PRIORITY: Record<string, number> = Object.fromEntries(
  Object.entries(CRM_DATA_TYPE_CONFIG).map(([key, config]) => [key, config.order]),
);

/**
 * Mapping from existing data types to toolsToValidate values
 */
export const DATA_TYPE_TO_TOOLS_TO_VALIDATE_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(CRM_DATA_TYPE_CONFIG).map(([key, config]) => [key, config.validationKey]),
);

/**
 * Mapping from validation enum values (ACCOUNTS, CONTACTS, etc.) to job config tool types (load_positions_transactions, etc.)
 * This is derived from CRM_DATA_TYPE_CONFIG to maintain single source of truth
 */
export const VALIDATION_ENUM_TO_JOB_CONFIG_TOOL_TYPE_MAP: Record<string, string> = {
  // Map display names from CRM_DATA_TYPE_CONFIG to validation enum values, then to tool types
  ACCOUNTS: CRM_DATA_TYPE_CONFIG.accounts.toolType,
  CONTACTS: CRM_DATA_TYPE_CONFIG.contacts.toolType,
  NOTES: CRM_DATA_TYPE_CONFIG.notes.toolType,
  COMM_PREFS: CRM_DATA_TYPE_CONFIG.comm_pref.toolType,
};
